import { Eye } from 'lucide-solid'
import { useService } from 'solid-services'
import { Flex } from 'styled-system/jsx'
import { useChannelsReads } from '../../../../../state/channelReads/state'
import { useCreate } from '../../../Create/state'
import { useSingle } from '../../state'
import { ActionButton } from './ActionButton'
import { Score } from './Score'

const PencilIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M4 20h4L19 9l-4-4L4 16v4z" />
    <path d="M14 6l4 4" />
  </svg>
)

const ArrowRightIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

export const Actions = (props: { size?: 'main' | 'mobile'; gap?: string }) => {
  const { toggleTaken, takenQuery, subscribed, isArchived, setupQuery, takenCountQuery, subscribedCountQuery } = useService(useSingle)()
  const { upsertReadMutation, toggleSubscribed } = useService(useChannelsReads)()
  const { editSetup } = useService(useCreate)()

  const takenText = () =>
    takenQuery.data?.has_taken
      ? 'You have taken this setup'
      : 'Mark this setup as taken'
  const watchText = () =>
    subscribed() ? 'You are subscribed this setup' : 'Mark this setup as subscribed'

  const takenHeading = () => (takenQuery.data?.has_taken ? 'Taken' : 'Take')
  const watchHeading = () => (subscribed() ? 'Subscribed' : 'Subscribe')

  return (
    <Flex gap={props.gap || '6px'} flexWrap="nowrap">
      <ActionButton
        heading="Update"
        tooltip="Update Setup"
        onClick={() => editSetup(setupQuery.data as any)}
        icon={<PencilIcon />}
        size={props.size}
      />
      <ActionButton
        heading={watchHeading()}
        tooltip={watchText()}
        disabled={isArchived()}
        bubble={subscribedCountQuery.data?.toString()}
        loading={upsertReadMutation.isPending}
        active={!!subscribed()}
        onClick={() => toggleSubscribed(setupQuery.data?.channel_id || undefined)}
        icon={<Eye stroke-width={1.9} />}
        size={props.size}
      />
      <ActionButton
        heading={takenHeading()}
        tooltip={takenText()}
        disabled={isArchived()}
        bubble={takenCountQuery.data?.toString()}
        loading={takenQuery.isLoading}
        active={!!takenQuery.data?.has_taken}
        onClick={toggleTaken}
        icon={<ArrowRightIcon />}
        size={props.size}
      />
      <Score size={props.size} />
    </Flex>
  )
}
